<template>
  <div
    ref="chartDom"
    v-loading="loading"
    style="height: 100%; min-height: 320px"
  />
</template>
  
<script>
let echarts = require("echarts");
let elementResizeDetectorMaker = require("element-resize-detector");
export default {
  data() {
    return {
      loading: false,
      options: this.$utils.meta.items("demand-step-client"),
      queryParams: { ...this.params },
    };
  },
  props: {
    params: { type: Object },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.job.demand.statis
        .states(this.queryParams)
        .then((res) => {
          let option = {
            title: {
              text: "线索销售漏斗",
              left: "center",
              bottom: 0,
            },
            tooltip: {
              trigger: "item",
              formatter: "{b} : {c}条",
            },
            series: [
              {
                type: "funnel",
                sort: "none",
                label: {
                  position: "outside",
                },
                width: "80%",
                minSize: "1%",
                left: "5%",
                labelLine: {
                  length: 30,
                },
                itemStyle: {
                  borderColor: "#fff",
                  borderWidth: 1,
                },
                emphasis: {
                  label: {
                    fontSize: 20,
                  },
                },
                data: this.options.map((t) => {
                  return {
                    name: t.text,
                    value: res.find((x) => x.text == t.value)?.value ?? 0,
                  };
                }),
              },
            ],
          };
          const chart = this.$refs["chartDom"];
          if (chart) {
            let myChart = echarts.init(chart);
            myChart.setOption(option);
            //刷新响应
            elementResizeDetectorMaker().listenTo(chart, function () {
              myChart.resize();
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>